import _defineProperty from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import * as tslib_1 from "tslib";
import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";
import { forwardRefAs, Generic } from "../../base";
export var FIELD_LABEL_DEFAULTS = {
  sizes: ["small", "normal", "medium", "large"]
};
export var FieldLabel = forwardRefAs(function (_a, ref) {
  var className = _a.className,
      size = _a.size,
      rest = tslib_1.__rest(_a, ["className", "size"]);

  return React.createElement(Generic, Object.assign({
    className: classNames("field-label", _defineProperty({}, "is-".concat(size), size), className),
    ref: ref
  }, rest));
}, {
  as: "div"
});
FieldLabel.displayName = "Field.Label";
FieldLabel.propTypes = {
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};